import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import React, { useLayoutEffect, useRef } from 'react';
import styled from 'styled-components';
import rocket from '../assets/timeline_img.png';

const RocketContainer = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 200px; /* Adjust based on the size of your rocket image */
  height: auto;
  overflow: hidden;

  img {
    width: 100%;
    height: auto;
    display: block; /* Ensure the image scales correctly */
  }

  @media (max-width: 48em) {
    left: 1rem;
  }
`;

const DrawSvg = () => {
  const ref = useRef(null);

  gsap.registerPlugin(ScrollTrigger);

  useLayoutEffect(() => {
    const element = ref.current;
    const screenHeight = window.innerHeight;
    const contentHeight = document.body.offsetHeight;
    const travelDistance = contentHeight - screenHeight;
  
    console.log(`Travel Distance: ${travelDistance}`); // Debugging
  
    gsap.registerPlugin(ScrollTrigger);
  
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: "top center",
        end: () => `+=${travelDistance}`,
        scrub: 3,
      }
    });
  
    tl.to(element, { y: travelDistance, ease: "none" });
  
    return () => {
      if (tl) tl.kill();
    };
  }, []);
  
  
  return (
    <RocketContainer ref={ref}>
      <img src={rocket} alt="Rocket" />
    </RocketContainer>
  )
}

export default DrawSvg;
